import { ExcelMapperConfig } from "@/utils/excel-mapper/excel-mapper-config";

export class ExcelMapperSettings {
	ID:number = 0;
	Context:string = "";
	Name:string = "";
	Settings:ExcelMapperConfig = new ExcelMapperConfig();

	public constructor(data?:any) {
		if (!data) return;
		this.ID = data.ID;
		this.Context = data.Context;
		this.Name = data.Name;
		this.Settings = new ExcelMapperConfig(data.Settings);
	}

	public getJSON():any {
		return {
			ID: this.ID,
			Context: this.Context,
			Name: this.Name,
			Settings: this.Settings.getJSON()
		};
	}
}